import { i18n } from 'src/boot/i18n';

export const splitDelimiter = '___';
export const workflowSplitDelimiter = '__%';
export const invalid = 'invalid';
export { REGION_STORAGE_KEY } from 'src/pages/api-base-url';
export const workflowTranslationDelimiter = 'trnsl_%';
export const tableRowIdPreFix = 'tbl_row_';
export const masterDataPrefix = 'MASTER_DATA_';
export const masterDataLabelPrefix = masterDataPrefix + 'LABEL_';

export const specialChars = String.raw`!@#$%^&*()_+=\[{\]};:,.<>?/\\|~-`;
export const passwordPattern = new RegExp(
  `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${specialChars}])[A-Za-z\\d${specialChars}]{8,20}$`,
);

export let includeColumnsForPO = [
  'org_id',
  'item_id',
  'unit_code',
  'currency',
  'net_amount',
  'description',
  'line_number',
  'sub_line_number',
  'supplier_id',
  'supplier_item_id',
  'purchase_order_id',
  'purchase_order_number',
  'delivery_line_number',
  'delivery_number',
  'packing_slip_number',
];

export let all_statuses = [
  'new',
  'restarted',
  'restart_in_progress',
  'running',
  'classified',
  'validating',
  'ready_for_validation',
  'ready_for_review',
  'pending_confirmation',
  'validated_pending_approval',
  'approved_pending_second_approval',
  'rejected',
  'exporting',
  'pending_watcher_export',
  'pending_watcher_alternate_export',
  'workflow',
  'error',
  'finished',
  'archived',
  'validated_pending_export',
  'completed',
  'export_error',
  'restart_export',
  'in_progress',
];

export let static_statuses = [
  'classified',
  'ready_for_validation',
  'ready_for_review',
  'pending_confirmation',
  'validated_pending_approval',
  'approved_pending_second_approval',
  'rejected',
  'workflow',
  'error',
  'finished',
];

export let alternate_export_statuses_all = [
  'classified',
  'pending_confirmation',
  'validated_pending_approval',
  'approved_pending_second_approval',
  'validated_pending_export',
  'approved_pending_export',
  'rejected',
  'finished',
  'on_hold',
  'workflow',
  'error',
  'in_review',
];

export let allowedDocTypes = [
  'INVOICE',
  'CUSTOMER_ORDERS',
  'DELIVERY_NOTE',
  'ORDER_CONFIRMATION',
  'CONTRACT',
  'XML_INVOICE',
];

export let layoutBuilderAllowedDocTypes = [
  'MEDICAL_RECEIPT',
  'PATIENT_FORM',
  'PROCESS_FORM',
  'INVOICE',
  'CUSTOMER_ORDERS',
  'DELIVERY_NOTE',
  'ORDER_CONFIRMATION',
  'CONTRACT',
  'XML_INVOICE',
];

export let readOnlyDocStatus = [
  'finished',
  'workflow',
  'pending_watcher_export',
  'pending_watcher_alternate_export',
  'pending_erp_approval',
  'rejected',
  'error',
  'export_error',
  'archived',
];
export let validationScreenStatuses = [
  'finished',
  'workflow',
  'pending_watcher_export',
  'pending_watcher_alternate_export',
  'pending_erp_approval',
  'ready_for_validation',
];

export let number_column_types = ['amount', 'number'];

export const rowRgbaColor =
  'linear-gradient( rgba(127, 17, 224, 0.2) 100%, rgba(0, 0, 0, 0.5)100%)';
// export const columnRgbaColor = 'linear-gradient(rgba(152, 65, 14, 0.2) 100%, rgba(0, 0, 0, 0.5) 100%)';
export const rowRgbaColorStr =
  'linear-gradient( rgba(127, 17, 224, 0.2) 100%, rgba(0, 0, 0, 0.5)100%), ';

export const LOW_OCR_CONFIDENCE = 'LOW_OCR_CONFIDENCE';

export const LOW_CONFIDENCE = ['LOW_OCR_CONFIDENCE', 'LOW_MATCH_SCORE'];

export function isDocTypeInvoice(doc_type: string) {
  if (
    doc_type == 'INVOICE' ||
    doc_type == 'DELIVERY_NOTE' ||
    doc_type == 'ORDER_CONFIRMATION' ||
    doc_type == 'CUSTOMER_ORDERS'
  ) {
    return true;
  }
  return false;
}

export function isInvoice(doc_type: string) {
  if (doc_type == 'INVOICE') return true;
  else return false;
}

export const CONSTANTS = {
  INVOICE: 'Invoice',
  finished: 'finished',
  export_error: 'export_error',
  group_key: 'dashboard_groups',
  group_parent_indexes: 'group_parent_indexes',
  dashboard_columns_pref_key: 'DASHBOARD_COLUMNS',
  duplicate_docs_columns_pref_key: 'DUPLICATE_DOCS_COLUMNS',
  group_parent_raw_where: 'group_parent_raw_where',
  ready_for_validation: 'ready_for_validation',
  reject_and_correct: 'reject_and_correct',
  approve_and_correct: 'approve_and_correct',
  restart_workflow: 'restart_workflow',
  export_and_next: 'export_and_next',
  view_summery: 'view_summery',
  in_review: 'in_review',
  save: 'save',
  export: 'export',
  reject: 'reject',
  coa: 'certificate_of_analysis',
  rejected: 'rejected',
  po_match: 'po_match',
  save_rules: 'save_rules',
  quotes_detail: 'quotes_detail',
  request_release: 'request_release',
  monitor_preference: 'MONITOR_PREFERENCE',
  dual_monitor_mode_setting: 'DUAL_MONITOR_MODE_SETTING',
  export_without_validation: 'export_without_validation',
  export_with_sonderwunsche: 'export_with_sonderwunsche',
  validated_pending_approval: 'validated_pending_approval',
  approved_pending_second_approval: 'approved_pending_second_approval',
  pending_workflow_execution: 'pending_workflow_execution',
  all: 'All',
  static: 'Static',
  custom: 'Custom',
  ai_model: 'AI_MODEL',
  not_executed: 'not_executed',
  field_update: 'field_update',
  status_change: 'status_change',
  ai_ocr_version: 'AI_OCR_VERSION',
  deskew_document: 'DESKEW_DOCUMENT',
  use_ai_extraction: 'USE_AI_EXTRACTION',
  use_rules_extraction: 'USE_RULES_EXTRACTION',
  use_etext_if_available: 'USE_ETEXT_IF_AVAILABLE',
  show_extraction_insights: 'SHOW_EXTRACTION_INSIGHTS',
  when: 'when',
  and: 'and',
  then: 'then',
  additional_conditions: 'additional_conditions',
  additional_executions: 'additional_executions',
  user: 'user',
  group: 'group',
  operator: 'operator',
  math_operator: 'math_operator',
  mismatch: 'mismatch',
  priority: 'priority',
  percent: 'percent',
  po_dashboard: 'PO_DASHBOARD',
  po_date_limit: 'PO_DATE_LIMIT',
  selected_po_retention_period: 'SELECTED_PO_RETENTION_PERIOD',
  is_po_active: 'PO_IS_ACTIVE',
  po_unit_type: 'PO_UNIT_TYPE',
  PO_MATCH_RULES: 'PO_MATCH_RULES',
  po_shipment_order: 'PO_SHIPMENT_ORDER',
  po_quantity_column: 'PO_QUANTITY_COLUMN',
  quantity_tolerance: 'QUANTITY_TOLERANCE',
  unit_price_tolerance: 'UNIT_PRICE_TOLERANCE',
  po_unit_tolerance_type: 'PO_UNIT_TOLERANCE_TYPE',
  shipment_order_dashboard: 'SHIPMENT_ORDER_DASHBOARD',
  doc_operator_setting: 'DOC_OPERATOR_SETTING',
  docnet_setting: 'DOCNET_SETTING',
  docnet_dashboard_layout: 'DOCNET_DASHBOARD_LAYOUT',
  fellow_doc2: 'FELLOW_DOC2',
  doc_net: 'DOC_NET',
  vertex_tax: 'VERTEX_TAX',
  vertex_tax_integration_setting: 'VERTEX_TAX_INTEGRATION_SETTING',
  vertex_tax_variance_threshold: 'VERTEX_TAX_VARIANCE_THRESHOLD',
  vertex_tax_variance_type: 'VERTEX_TAX_VARIANCE_TYPE',
  vertex_verification_trigger: 'VERTEX_VERIFICATION_TRIGGER',
  supplier_statistics_setting: 'SUPPLIER_STATISTICS_SETTING',
  grouping_dashboard: 'DOC_SEARCH',
  bod_connection_stream: 'BOD_STREAM_CONNECTION',
  doc_operator: 'DOC_OPERATOR',
  db_read_only: 'DB_READ_ONLY',
  opensearch: 'AI_SEARCH',
  docflow: 'DOCFLOW',
  docflow_advanced: 'DOCFLOW_ADVANCED',
  analytics_dashboard: 'DOC_SEARCH',
  supplier_portal: 'PARTNER_PORTAL',
  // Backend uses this spelling (not "CONNECTOR")
  sql_bi_connecter: 'SQL_BI_CONNECTER',
  doc_scan: 'IDP_ADDON_WEB_SCAN',
  doc_net_app_id: 'e9a161d4-315a-4a25-8178-e5a8e3955e80',
  po_auto_match_and_export: 'PO_AUTO_MATCH_AND_EXPORT',
  po_quantity_tolerance_type: 'PO_QUANTITY_TOLERANCE_TYPE',
  auto_refresh_dashboard_on_update: 'AUTO_REFRESH_DASHBOARD_ON_UPDATE',
  additional_range_for_po_tolerance: 'ADDITIONAL_RANGE_FOR_PO_TOLERANCE',
  po_status_in_docs: 'UPDATE_DOCUMENT_PURCHASE_ORDER_STATUS',
  purchase_invoice: 'Purchase Invoice',
  invoice_sub_type: 'invoice_sub_type',
  freight_tolerance: 'FREIGHT_TOLERANCE',
  charges_tolerance: 'CHARGES_TOLERANCE',
  freight_unit_tolerance: 'FREIGHT_UNIT_TOLERANCE',
  charges_unit_tolerance: 'CHARGES_UNIT_TOLERANCE',
  tax_tolerance: 'TAX_TOLERANCE',
  tax_unit_tolerance: 'TAX_UNIT_TOLERANCE',
  custom_range_for_po_tolerance: 'CUSTOM_RANGE_FOR_PO_TOLERANCE',
  success_border_left: 'success-border-left',
  questionSymbol: '?',
  dateSplitBy: ' To ',
  costingElementIdPreFix: 'costing_element',
  DELIVERY_NOTE: 'DELIVERY_NOTE',
  AI_SYSTEM_PROMPT: 'AI_SYSTEM_PROMPT',
  ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
  AI_ASSISTANT_PROMPT: 'AI_ASSISTANT_PROMPT',
  TABLE_EXTRA_COLUMNS_: 'TABLE_EXTRA_COLUMNS_',
  DUPLICATE_DETECTION: 'DUPLICATE_DETECTION',
  DUPLICATE_DETECTION_FIELDS: 'DUPLICATE_DETECTION_FIELDS',
  DUPLICATE_INVOICE_DETECTION: 'DUPLICATE_INVOICE_DETECTION',
  IGNORE_TAX_FREE_LINE: 'IGNORE_TAX_FREE_LINE',
  DISALLOW_EXPORT_OF_DUPLICATES: 'DISALLOW_EXPORT_OF_DUPLICATES',
  default_separator_color: '#dddddd',
  INBOUND_EMAILS: 'INBOUND_EMAILS',
  DEFAULT_AI_MODEL: 'gpt-4o',
  export_pdf_format: 'EXPORT_FILE_FORMAT',
  ALLOW_MULTIPLE_EXPORT_CONFIGURATIONS: 'ALLOW_MULTIPLE_EXPORT_CONFIGURATIONS',
  auto_update_po_data: 'AUTO_UPDATE_PO_DATA',
  DOC_SCAN_MODULE_SETTING: 'DOC_SCAN_MODULE_SETTING',
  CALCULATE_PO_UNIT_PRICE: 'CALCULATE_PO_UNIT_PRICE',
  CONSUMED_PO_LINE_STATUS: 'CONSUMED_PO_LINE_STATUS',
  auto_check_for_po_update: 'AUTO_CHECK_FOR_PO_UPDATE',
  INFOR_ACL_UPDATER_SETTING: 'INFOR_ACL_UPDATER_SETTING',
  SPLIT_DOCUMENT_BARCODE_PATTERN: 'SPLIT_DOCUMENT_BARCODE_PATTERN',
  SPLIT_DOCUMENT_ON_BARCODE: 'SPLIT_DOCUMENT_ON_BARCODE',
  SPLIT_DOCUMENT_BARCODE_TYPE: 'SPLIT_DOCUMENT_BARCODE_TYPE',
  advanced_workflow_menu_label_when: 'advanced_workflow_menu_label_when',
  advanced_workflow_menu_label_and: 'advanced_workflow_menu_label_and',
  advanced_workflow_menu_label_then: 'advanced_workflow_menu_label_then',
  advanced_workflow_menu_label_delay: 'advanced_workflow_menu_label_delay',
  advanced_workflow_menu_label_hint: 'advanced_workflow_menu_label_hint',
  advanced_workflow_menu_label_any: 'advanced_workflow_menu_label_any',
  PO_MATCH_SERVER_SIDE: 'PO_MATCH_SERVER_SIDE',
  notify_requisitioner: 'notify_requisitioner',
  only_admin_can_save_rules: 'ONLY_ADMIN_CAN_SAVE_RULES',
  DUPLICATE_DETECTION_INTERVAL: 'DUPLICATE_DETECTION_INTERVAL',
  PO_MATCH_IGNORE_ITEM_NUMBER_FOR_SINGLE_LINE_MATCH: 'PO_MATCH_IGNORE_ITEM_NUMBER_FOR_SINGLE_LINE_MATCH',

  // ─── localStorage / sessionStorage key constants ───────────────────
  // Used by LogoutUtil.ts KEEP_ON_LOGOUT and across the app wherever
  // these keys are read / written.
  selected_language: 'selected_language',
  remembered_email: 'remembered_email',
  app_version: 'APP_VERSION',
  version_refresh_cooldown: 'versionRefreshCooldownUntil',
  tasks_list_mode: 'tasks_list_mode',
  full_search_filters: 'fullSearchFilters',
  import_log_columns: 'IMPORT_LOG_SETTING_COLUMNS',
  export_columns_order: 'EXPORT_SETTING_COLUMNS_ORDER',
  users_columns_order: 'USERS_SETTING_COLUMNS_ORDER',
  groups_columns_order: 'GROUPS_COLUMNS_ORDER',
  groups_sort_order: 'GROUPS_SORT_ORDER',
  sub_org_columns_order: 'SUB_ORG_COLUMNS_ORDER',
  email_template_columns_order: 'EMAIL_TEMPLATE_SETTING_COLUMNS_ORDER',
  email_notification_columns_order: 'EMAIL_NOTIFICATION_SETTING_COLUMNS_ORDER',
  supplier_email_template_columns_order: 'SUPPLIER_EMAIL_TEMPLATE_SETTING_COLUMNS_ORDER',
  custom_columns_order: 'CUSTOM_COLUMNS_ORDER',
  lov_value_columns_order: 'LOV_VALUE_COLUMNS_ORDER',
  classification_columns: 'CLASSIFICATION_EXTRACTION_SETTING_COLUMNS',
  tasks_columns: 'TASKS_COLUMNS_SETTING',
  tasks_list_settings: 'TASKS_LIST_SETTINGS',
  workflow_dashboard_filters: 'workflow_dashboard_filters',

  // Patterns (substrings) for dynamic user-based localStorage keys
  pattern_dashboard_filters: 'dashboard_filters_v2',
  // NOTE: 'dashboard_groups' pattern uses group_key above (no separate constant needed)
  pattern_dashboard_pagination: 'dashboard_pagination',
  pattern_column_filter: 'columnFilter_',
  pattern_order_by: 'orderBy_',
  pattern_log_settings: 'Log-Settings',
  pattern_email_import: 'emailImport',
  pattern_ftp_import: 'ftpImport',
  pattern_column_resize: 'columnResize',
  pattern_list_of_values: 'listOfValues',
  pattern_script_logs: 'script_logs_setting',
  pattern_master_data_tabs: 'masterDataTabs',
  pattern_lov_custom_order: 'lov_custom_order_',
};

export const GROUP_NAMES = {
  charges: 'charges',
  tax_details: 'tax_details',
};

export const DeliveryCache = {
  get_receive_delivery_cache: 'CACHE_POC',
  get_purchase_order_cache: 'CACHE_PO',
  get_task_and_notification_cache: 'CACHE_TN',
};
export const layout_types = {
  review: 'review',
  reject: 'reject',
  approval: 'approval',
  approval_v2: 'approval_v2',
  second_approval: 'second_approval',
  field_validation: 'field_validation',
  vertex_tax_verification: 'vertex_tax_verification',
};

export const RESTRICTED_FIELD_APPROVER_FIELDS = [
  'assigned_to',
  'first_approver',
];

export const QUOTE = 'QUOTE';
export const DEFAULT = 'DEFAULT';
export const LOGIN_PARAMS = 'LOGIN_PARAMS';
export const RULE_MANAGER = 'RULE_MANAGER';
export const M3_TOML_MAPPING = 'M3_TOML_MAPPING';
export const default_date_pattern = '%m/%d/%Y';
export const custom_master_data = 'CUSTOM_MASTER_DATA';
export const version_info_dialog = 'VERSION_INFO_DIALOG';
export const tasks_notification_setting = 'TASKS_NOTIFICATION_ACTIVATE_SETTING';
export const dashboard_tasks_count_activated =
  'DASHBOARD_TASKS_COUNT_ACTIVATED';
export const auto_accounting_setting = 'AUTO_ACCOUNTING_ACTIVATE_SETTING';
export const auto_accounting_reset_data_on_change_setting = 'AUTO_ACCOUNTING_RESET_DATA_ON_CHANGE';
export const auto_accounting_types_setting = 'AUTO_ACCOUNTING_TYPE';
export const auto_accounting_acc_list_name_setting =
  'AUTO_ACCOUNTING_ACOUNTS_LIST_NAME';
export const auto_accounting_po_acc_list_name_setting =
  'AUTO_ACCOUNTING_PO_ACOUNTS_LIST_NAME';
export const auto_accounting_dimensions_list_setting =
  'AUTO_ACCOUNTING_DIMENSION_LIST_NAME';
export const auto_accounting_dimensions_options_setting =
  'AUTO_ACCOUNTING_OPTIONS_DROPDOWN';
export const dimension_general_dropdown_accounting =
  'AUTO_ACCOUNTING_DIMENSION_GENERAL_DROPDOWN';
export const auto_accounting_fields_setting = 'AUTO_ACCOUNTING_FIELDS';
export const AI_table_extraction_setting = 'USE_AI_TABLE_EXTRACTION';
export const table_extraction_use_vision_setting = 'TABLE_EXTRACTION_USE_VISION';
export const table_extraction_setting = 'TABLE_EXTRACTION_SETTING';
export const dark_mode_setting = 'DARK_MODE';
export const date_pattern_setting = 'DATE_PATTERN';
export const amount_format_setting = 'AMOUNTS_LOCALE';
export const po_match_line_discount = 'PO_MATCH_LINE_DISCOUNT';
export const po_quantities_allowed_decimals = 'PO_QUANTITIES_ALLOWED_DECIMALS';
export const charges_table_extraction = 'CHARGES_TABLE_EXTRACTION';
export const auto_extract_tax_code_setting = 'AUTO_EXTRACT_TAX_CODE';
export const proccess_unsupported_zugferd_setting =
  'PROCESS_UNSUPPORTED_ZUGFERD';
export const TIME_UNIT_MINUTES = 'minutes';
export const ALLOW_MULTIPLE_SUPPLIER_ACCOUNTS_SYNC_SETTING =
  'ALLOW_MULTIPLE_SUPPLIER_ACCOUNTS_SYNC';

// Dashboards
export const LONG_REQUEST_THRESHOLD = 60000;
export const grouping_dashboard_setting = 'GROUPING_DASHBOARD';
export const grouping_purchase_order_setting = 'GROUPING_PURCHASE_ORDER';
export const supplier_dashboard_setting = 'SUPPLIER_DASHBOARD';
export const supplier_portal_with_layout_setting =
  'SUPPLIER_PORTAL_WITH_LAYOUT';
export const supplier_portal_additional_fields_preference =
  'SUPPLIER_PORTAL_ADDITIONAL_FIELDS_PREFERENCE';
export const supplier_portal_additional_fields =
  'SUPPLIER_PORTAL_ADDITIONAL_FIELDS';
export const warehouse_reporting_engine_setting = 'WAREHOUSE_REPORTING_ENGINE';
export const warehouse_username_setting = 'WAREHOUSE_USERNAME';
export const warehouse_password_setting = 'WAREHOUSE_PASSWORD';
export const warehouse_host_setting = 'WAREHOUSE_HOST';
export const warehouse_port_setting = 'WAREHOUSE_PORT';
export const warehouse_database_setting = 'WAREHOUSE_DATABASE';
export const warehouse_tables_setting = 'WAREHOUSE_TABLES';
export const asn_dashboard_setting = 'ASN_DASHBOARD';
export const export_dashboard_data_setting = 'EXPORT_DASHBOARD_DATA';
export const workflow_builder_setting = 'WORKFLOW_BUILDER_MODULE_SETTING';
export const report_setting = 'REPORT_PAGE';
export const analytics_dashboard_setting = 'ANALYTICS_DASHBOARD';
export const quality_analytics_use_database = 'QUALITY_ANALYTICS_USE_DATABASE';
export const invoice_dashboard_setting = 'INVOICE_DASHBOARD';
export const invoice_dashboard_columns_setting = 'INVOICE_DASHBOARD_COLUMNS';
export const coa_dashboard_setting = 'COA_DASHBOARD';
export const coa_dashboard_columns_setting = 'COA_DASHBOARD_COLUMNS';
export const fact_sheet_pdf_setting = 'FACT_SHEET_PDF';
export const open_search_enabled = 'OPENSEARCH_ENABLED';
export const invoice_document_setting = 'INVOICE_DOCUMENT';
export const purchase_order_dashboard_columns =
  'PURCHASE_ORDER_DASHBOARD_COLUMNS';
export const advance_shipment_dashboard_columns =
  'ADVANCE_SHIPMENT_DASHBOARD_COLUMNS';
export const supplier_dashboard_columns = 'SUPPLIER_DASHBOARD_COLUMNS_V1'; //Changed from SUPPLIER_DASHBOARD_COLUMNS
export const shipment_order_dashboard_columns =
  'SHIPMENT_ORDER_DASHBOARD_COLUMNS';
export const barcode_assignment_setting = 'BARCODE_ASSIGNMENT_SETTING';
export const doc_operator_setting = 'DOC_OPERATOR_SETTING';
export const docnet_setting = 'DOCNET_SETTING';
export const docnet_dashboard_layout = 'DOCNET_DASHBOARD_LAYOUT';
export const db_direct_access_setting = 'DB_REPORTING_ENGINE';
export const db_access_username_setting = 'DB_USERNAME';
export const db_access_password_setting = 'DB_PASSWORD';
export const db_access_host_setting = 'DB_HOST';
export const db_access_port_setting = 'DB_PORT';
export const db_access_database_setting = 'DB_DATABASE';
export const db_access_tables_setting = 'DB_TABLES';

// dashboard
export const filters_reset_after_upload_setting = 'FILTERS_RESET_AFTER_UPLOAD';
export const filters_reset_after_restart_setting =
  'FILTERS_RESET_AFTER_DOC_RESTART';
export const filters_reset_after_export_setting =
  'FILTERS_RESET_AFTER_DOC_EXPORT';
export const status_filter_style_setting = 'STATUS_FILTER_STYLE';
export const action_assign_to = 'ACTION_ASSIGN_TO';
export const action_restart = 'ACTION_RESTART';
export const action_return_to_validation = 'ACTION_RETURN_TO_VALIDATION';
export const status_filter_list = 'STATUS_FILTER_LIST';
export const delivered_order_days = 'DELIVERED_ORDER_DAYS';
export const user_selected_dashboard_filters =
  'USER_SELECTED_DASHBOARD_FILTERS';
export const selected_dashboard_pref_key = 'SELECTED_DASHBOARD';
export const sorted_doc_type_tabs_pref_key = 'SORTED_DOC_TYPE_TABS';

export const document_expiry_setting = 'DOCUMENTS_EXPIRY';
export const user_sub_org_id_setting = 'USER_SELECTED_SUB_ORG_ID';
export const group_permission_activated = 'GROUP_PERMISSION_ACTIVATED';
export const finished_document_expiry_setting = 'FINISHED_DOCUMENTS_EXPIRY';

export const po_columns = 'PO_COLUMNS';
export const approval_stamp = 'APPROVAL_STAMP';
export const approval_history = 'APPROVAL_HISTORY';
export const po_table_columns = 'PO_TABLE_COLUMNS';
export const pdf_export_to_idm = 'PDF_EXPORT_TO_IDM';
export const pdf_template = 'PDF_TEMPLATE_GENERATION';
export const po_tab_table_columns = 'PO_TAB_TABLE_COLUMNS';
export const skip_table_validation = 'SKIP_TABLE_VALIDATION';
export const approve_before_export = 'APPROVE_BEFORE_EXPORT';
export const approve_before_export_v2 = 'APPROVE_BEFORE_EXPORT_V2';
// E-Invoice validation (BOL-401 / BOL-413) — per-DocType toggle that
// activates the XRechnung / ZUGFeRD / Factur-X validator pipeline.
export const xrechnung_validation_enabled = 'XRECHNUNG_VALIDATION_ENABLED';
// Per-DocType opt-in for the supplier-email notification on rejection
// (BOL-415, handled by a DocNet agent — DocBits_API just enqueues).
export const xrechnung_supplier_notification_enabled =
  'XRECHNUNG_SUPPLIER_NOTIFICATION_ENABLED';
export const po_disabled_statuses_setting = 'PO_DISABLED_STATUSES';
export const doc_script_module_setting = 'DOC_SCRIPT_MODULE_SETTING';
export const models_labels_module_setting = 'MODELS_LABELS_MODULE_SETTING';
export const second_approval_before_export = 'SECOND_APPROVAL_BEFORE_EXPORT';

export const doc_alternate_export_export_config =
  'DOC_ALTERNATE_EXPORT_EXPORT_CONFIG';
export const doc_alternate_export_setting = 'DOC_ALTERNATE_EXPORT_SETTING';
export const doc_alternate_export_status = 'DOC_ALTERNATE_EXPORT_STATUS';
export const po_table_in_layout_builder = 'PO_TABLE_IN_LAYOUT_BUILDER';
export const bod_connection_stream_setting = 'BOD_CONNECTION_STREAM';
export const supplier_portal_setting = 'SUPPLIER_PORTAL_SETTING';

export const export_non_matched_po_lines = 'EXPORT_NON_MATCHED_PO_LINES';
export const dashboard_pagination = 'DASHBOARD_PAGINATION';
export const amount_rounding_setting = 'AMOUNTS_ROUNDING';
export const all_sub_org_setting = 'ALL_SUB_ORG_SETTING';
export const walkthrough_completed_setting = 'WALKTHROUGH_COMPLETED';
export const DEFAULT_LANGUAGE = 'en-us';
export const DEFAULT_ORG_UUID = '00000000-0000-0000-0000-000000000000';

export function isDefaultOrg(orgId: string): boolean {
  return orgId === DEFAULT_ORG_UUID;
}
export const preferred_language_setting = 'PREFERRED_LANGUAGE';
export const line_table_columns = 'LINE_TABLE_COLUMNS';
export const sub_org_sort_order = 'SUB_ORG_SORT_ORDER';
export const line_item = 'line_item';

export const po_tolerance_type = [
  {
    label: '%',
    value: CONSTANTS.percent,
  },
  {
    label: i18n.t('value'),
    value: 'value',
  },
];

export const conflict_handle_options = [
  { label: 'Best Score', value: 'BEST_SCORE' },
  { label: 'Return None', value: 'RETURN_NONE' },
  { label: 'Return First', value: 'RETURN_FIRST' },
];

export const info_panel_chip_colors = [
  'purple',
  'indigo',
  'cyan',
  'teal',
  'green',
  'deep-orange',
  'blue-grey',
];
export const allowed_file_types = [
  'application/pdf',
  'image/tiff',
  'image/png',
  'image/jpg',
  'image/jpeg',
  'text/xml',
  'edi',
  'purchaseorder',
];

// File extensions accepted for upload. Used as the source of truth when a
// browser omits/garbles `File.type` (empty MIME on drag-and-drop from some
// sources), so a valid file is not rejected just because its MIME type is
// missing. Covers the file-bearing entries of `allowed_file_types` (plus `tif`
// alongside `tiff`); the non-standard tokens `edi`/`purchaseorder` in that list
// are not real MIME types — only `edi` maps to a plausible extension.
// When you change one list, update the other (a guard test in
// src/utils/__tests__/fileType.unit.spec.ts checks the core types stay aligned).
export const allowed_file_extensions = [
  'pdf',
  'tif',
  'tiff',
  'png',
  'jpg',
  'jpeg',
  'xml',
  'edi',
];

export const excluded_doctype_tabs = ['SUPPLIER_M3'];

export const allowed_file_type_json = ['application/json'];

export const e_document_types = [
  { label: 'FATTERAPA', value: 'FATTERAPA' },
  { label: 'EDI', value: 'EDI' },
  { label: 'BOD', value: 'BOD' },
];

export const attribute_names = [
  { label: 'STRUCTURE DESCRIPTOR', value: 'STRUCTURE_DESCRIPTOR' },
  { label: 'TRANSFORMATION', value: 'TRANSFORMATION' },
  { label: 'EXTRACTION PATHS', value: 'EXTRACTION_PATHS' },
  { label: 'PREVIEW', value: 'PREVIEW' },
];

export const quotes_detail_table_order = [
  { name: 'POSITION', order: 1 },
  { name: 'DIMENSION2', order: 2 },
  { name: 'WAREHHOUSE', order: 3 },
  { name: 'SHIP_TO_LOCATION', order: 4 },
  { name: 'DIMENSION3', order: 5 },
  { name: 'ITEM_NUMBER', order: 6 },
  { name: 'DIMENSION1', order: 7 },
  { name: 'DIMENSION5', order: 8 },
  { name: 'DELIVERY_DATE', order: 9 },
  { name: 'SUPPLIER_ITEM_NUMBER', order: 10 },
  { name: 'DESCRIPTION', order: 11 },
  { name: 'UNIT_PRICE', order: 12 },
  { name: 'QUANTITY', order: 13 },
  { name: 'NET_AMOUNT', order: 14 },
  { name: 'TOTAL_AMOUNT', order: 15 },
  { name: 'ITEM_GROUP', order: 16 },
  { name: 'GL_ACCOUNTING_STRING', order: 17 },
  { name: 'INTERNAL_NOTES', order: 18 },
];
export const assign_to_option = [
  {
    label: 'Only for Admin',
    value: 'only_admin',
  },
  {
    label: 'All Users',
    value: 'all_user',
  },
];

export const restart_option = [
  {
    label: 'Only for Admin',
    value: 'only_admin',
  },
  {
    label: 'Only Admin and Assignee',
    value: 'only_admin_assignee',
  },
  {
    label: 'All Users',
    value: 'all_user',
  },
];
export const attribute_types = [
  { label: 'XSLT', value: 'XSLT' },
  { label: 'JSON', value: 'JSON' },
  { label: 'XML', value: 'XML' },
];

export const approvalInfoStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
};

export const dateFormates = {
  date_time: 'YYYY-MM-DD HH:mm:ss',
  date_only: 'YYYY-MM-DD',
};

export const supplierDocTypeKey = ['SUPPLIER_LAYOUT'];

export const inbound_emails_setting = 'INBOUND_EMAILS';

export const restAccountingByFields = [
  'invoice_sub_type',
  'invoice_sub_type_us_cad',
];

export const accountingEffectedByFields = [
  'tax_rate',
  'net_amount',
  'tax_amount',
  'tax_country',
  'tax_code_without_country',
  'total_amount',
];

export const ACCOUNTING_ELEMENT_FIELD_PREFIXES = [
  'tax_code_without_country',
  'net_amount',
  'tax_country',
];

export const allSubOrgsMenu = {
  created_by: 0,
  org_id: '',
  name: 'CROSS',
  last_modified_on: null,
  description: 'CROSS',
  id: '', // will be same like org id
  created_on: '',
  is_deleted: false,
};

export const aiModelList = [
  {
    label: 'Full',
    value: 'gpt-5.5',
  },
  {
    label: 'Fast',
    value: 'gpt-5.4-mini',
  },
  {
    label: 'Turbo',
    value: 'gpt-5.4-nano',
  },
  // {
  //   label: 'Mistral',
  //   value: 'mistral-large-3:675b-cloud',
  // },
];

export const YYYY_MM = 'YYYY-MM';

export const doc_lock_key = 'doc_lock_key';
export const activate_long_cache = 'DASHBOARD_LONG_CACHE_ACTIVATED';
export const ignore_already_matched_lines = 'IGNORE_ALREADY_MATCHED_LINES';
export const skip_hybrid_pdf_xml_extraction = 'SKIP_HYBRID_PDF_XML_EXTRACTION';
export const set_negative_sign_for_credit_notes = 'SET_NEGATIVE_SIGN_FOR_CREDIT_NOTES';
export const tasks = 'tasks';
export const columnResizeKey = 'columnWidths_';
export const tableFilterStorageKey = 'TABLE_FILTERS_';
export const edocFormatFilterStorageKey = 'EDOC_FORMAT_FILTER_';
export const quoteTypeManaged = 'MANAGED';
export const quoteTypeUnmanaged = 'UNMANAGED';
export const tasks_pagination_size = 'TASK_PAGINATION_SIZE';
export const amount_no_rounding_setting = 'AMOUNTS_NO_ROUNDING';
export const allow_auto_export_for_non_matchable_po_lines =
  'ALLOW_AUTO_EXPORT_FOR_NON_MATCHABLE_PO_LINES';

export const colorMapForCharts = {
  barcode: '#2F80ED',
  core: '#27AE60',
  'core.after_barcode_extraction': '#F2994A',
  extraction: '#EB5757',
  ocr: '#9B51E0',
  po_match: '#2D9CDB',
};

export function prepareExportBtnOptions() {
  const buttonsTypes = [
    {
      label: i18n.t(CONSTANTS.export),
      value: CONSTANTS.export,
    },
    {
      label: i18n.t(CONSTANTS.export_with_sonderwunsche),
      value: CONSTANTS.export_with_sonderwunsche,
    },
    {
      label: i18n.t(CONSTANTS.export_without_validation),
      value: CONSTANTS.export_without_validation,
    },
    {
      label: i18n.t(CONSTANTS.po_match),
      value: CONSTANTS.po_match,
    },
    {
      label: i18n.t(CONSTANTS.save_rules),
      value: CONSTANTS.save_rules,
    },
    {
      label: i18n.t(CONSTANTS.save),
      value: CONSTANTS.save,
    },
    {
      label: i18n.t(CONSTANTS.reject),
      value: CONSTANTS.reject,
    },
    {
      label: i18n.t(CONSTANTS.quotes_detail),
      value: CONSTANTS.quotes_detail,
    },
    {
      label: i18n.t(CONSTANTS.coa),
      value: CONSTANTS.coa,
    },
  ];

  return buttonsTypes;
}

export function prepareApprovalBtnOptions() {
  const buttonsTypes = [
    {
      label: i18n.t(CONSTANTS.save),
      value: CONSTANTS.save,
    },
    {
      label: i18n.t(CONSTANTS.request_release),
      value: CONSTANTS.request_release,
    },
    {
      label: i18n.t(CONSTANTS.reject),
      value: CONSTANTS.reject,
    },
    {
      label: i18n.t(CONSTANTS.in_review),
      value: CONSTANTS.in_review,
    },
    {
      label: i18n.t(CONSTANTS.restart_workflow),
      value: CONSTANTS.restart_workflow,
    },
    {
      label: i18n.t(CONSTANTS.reject_and_correct),
      value: CONSTANTS.reject_and_correct,
    },
    {
      label: i18n.t(CONSTANTS.approve_and_correct),
      value: CONSTANTS.approve_and_correct,
    },
    {
      label: i18n.t(CONSTANTS.export_and_next),
      value: CONSTANTS.export_and_next,
    },
    {
      label: i18n.t(CONSTANTS.view_summery),
      value: CONSTANTS.view_summery,
    },
    {
      label: i18n.t(CONSTANTS.notify_requisitioner),
      value: CONSTANTS.notify_requisitioner,
    },
  ];

  return buttonsTypes;
}

export const qr_code_extraction_setting = 'QR_CODE_EXTRACTION';
export const qr_bar_code_type_for_extraction = 'BARCODE_EXTRACTION_TYPES';
export const quote_fields_to_hide = ['ITEM_GROUP'];
export const invoice_date_limit = 'INVOICE_DATE_LIMIT';
// WebSocket should send ALL status updates - no exceptions
// The dashboard filter (user settings) controls what statuses are displayed,
// but WebSocket notifications should always trigger for any status change
export const status_to_skip_update = [];

export const po_retention_period = [
  { label: '3_months', value: '3 MONTH' },
  { label: '6_months', value: '6 MONTH' },
  { label: '1_year', value: '1 YEAR' },
  { label: '2_years', value: '2 YEAR' },
  { label: '3_years', value: '3 YEAR' },
  { label: '4_years', value: '4 YEAR' },
  { label: '5_years', value: '5 YEAR' },
];

export const rules_options_filter = [
  {
    type: 'SUPPLIER_M3',
    values: [
      'collect_sum',
      'collect_min',
      'collect_max',
      'collect_count',
      'first & adjacent',
      'first & next',
    ],
  },
];

export const supplier_statuses = 'SUPPLIER_STATUSES';
export const vendor_id_grouping = 'VENDOR_ID_GROUPING';
export const permission_groups_to_exclude = [
  'SUPPLIER_USER',
  'SUPPLIER_MANAGEMENT',
  'SUPPLIER_M3',
];
export const status_color_codes = {
  active: 'green',
  approved: 'grey',
  draft: 'orange',
};

/**
 * Maps appKey → plan key prefixes used by the subscription dialog and startup validation.
 * Single source of truth for resolving which plans belong to which feature.
 */
export const APP_KEY_PLAN_PREFIXES: Record<string, string[]> = {
  DOC_OPERATOR: ['OPERATOR'],
  DOC_SEARCH: ['AI_WAREHOUSE'],
  AI_SEARCH: ['AI_SEARCH'],
  DOCFLOW: ['DOCFLOW_STANDARD', 'DOCFLOW_SANDBOX'],
  DOCFLOW_ADVANCED: ['DOCFLOW_ADVANCED'],
  BOD_STREAM_CONNECTION: ['BOD_STREAM_CONNECTION'],
  VERTEX_TAX: ['VERTEX_TAX'],
};

